import Decimal from "decimal.js";
// window.Decimal = Decimal;
// 设置精度
Decimal.set({ precision: 30 });

const defaultSignalTransform = [1, 0];
// 转换规则 [factor, offet]
export const signalTransformMap = {
  /* output */
  UITx_ActuatorEna_SbW: [1, 0],
  UITx_ActuatorEna_Rws: [1, 0],
  UITx_ActuatorEna_FAS: [1, 0],
  UITx_ActuatorEna_DTD: [1, 0],
  UITx_CoStab: [0.05, -1],
  UITx_CoStaticChar: [0.05, -1],
  UITx_CoDynChar: [0.05, -1],
  UITx_TAA_Ena: [1, 0],
  UITx_TAA_ModeSelect: [1, 0],
  UITx_DisableBrk_FL: [1, 0],
  UITx_DisableBrk_FR: [1, 0],
  UITx_DisableBrk_RL: [1, 0],
  UITx_DisableBrk_RR: [1, 0],
  // UITx_AWS_ModeSelect: [1, 0],
  UITx_CST_Ena: [1, 0],
  UITx_DST_Ena: [1, 0],
  UITx_SbTv_Ena: [1, 0],
  UITx_DMC_Ena: [1, 0],
  UITx_RollingCounter: [1, 0],
  UITx_FrontVgrSw: [1, 0],
  // UITx_RearCtrlSw: [1, 0],
  UITx_SbTvRwsEna: [1, 0],
  UITx_DURrst: [1, 0],
  UITx_AdaDrvrCtrlSt: [1, 0],
  UITx_VLMReset: [1, 0],
  UITx_HDCCfg: [1, 0],

  /* input */
  UIRx_DeltaOff_FA: [0.015, -1.5],
  UIRx_DeltaOff_RA: [0.015, -1.5],
  UIRx_AxleStAng_FA: [0.1, -51.2],
  UIRx_AxleStAng_RA: [0.05, -10],
  UIRx_mueFL: [0.1, 0],
  UIRx_mueFR: [0.1, 0],
  UIRx_mueRL: [0.1, 0],
  UIRx_mueRR: [0.1, 0],
  UIRx_TAAAct: [1, 0],
  UIRx_PitchAng: [0.1, -6],
  UIRx_DMCTgtMod_FA: [1, 0],
  UIRx_DMCTgtMod_RA: [1, 0],
  UIRx_DMCWrkSt_FA: [1, 0],
  UIRx_DMCWrkSt_RA: [1, 0],
  UIRx_MotTq_FA: [0.1, -800],
  UIRx_MotTq_RA: [0.1, -800],
  UIRx_DUFlg_FL: [1, 0],
  UIRx_DUFlg_FR: [1, 0],
  UIRx_DUFlg_RL: [1, 0],
  UIRx_DUFlg_RR: [1, 0],
  UIRx_DUIdx_FL: [1, 0],
  UIRx_DUIdx_FR: [1, 0],
  UIRx_DUIdx_RL: [1, 0],
  UIRx_DUIdx_RR: [1, 0],
  UIRx_SuspHgtAmp_FL: [0.03, 0],
  UIRx_SuspHgtAmp_FR: [0.03, 0],
  UIRx_SuspHgtAmp_RL: [0.03, 0],
  UIRx_SuspHgtAmp_RR: [0.03, 0],
  UIRx_ACUYawRate: [0.25, -120],
  UIRx_ACULongdAcc: [0.02, -2],
  UIRx_ACULatAcc: [0.02, -2],
  UIRx_SBW_HWAAng: [0.1, -780],
  UIRx_WhlBrkTqAct_FL_BCh1: [5, 0],
  UIRx_WhlBrkTqAct_FR_BCh1: [5, 0],
  UIRx_WhlBrkTqAct_RL_BCh1: [5, 0],
  UIRx_WhlBrkTqAct_RR_BCh1: [5, 0],
  UIRx_XCU_FrontAxleDecTorqReq: [1, 0],
  UIRx_XCU_RearAxleDecTorqReq: [1, 0],
  UIRx_VehSpd: [0.15, 0],
  UIRx_FLWhlSpd_BCh1: [0.15, 0],
  UIRx_FRWhlSpd_BCh1: [0.15, 0],
  UIRx_RLWhlSpd_BCh1: [0.15, 0],
  UIRx_RRWhlSpd_BCh1: [0.15, 0],
  UIRx_ActuGearSta: [1, 0],
  UIRx_ABSSplitCtrlSts_BCh1: [1, 0],
  UIRx_DrvrReqTrgtFxBrk_Bch1: [8, -125000],
  UIRx_VehSdsl: [1, 0],
  UIRx_alphaRA: [0.05, -25],
  UIRx_OrgYawRate: [0.25, -120],
  UIRx_FrontGearRto: [0.1, 0],
  UIRx_RearGearRto: [0.01, -0.32],
  // WhlBrkTqAct_FL_BCh1: [5, 0],
  // WhlBrkTqAct_FR_BCh1: [5, 0],
  // WhlBrkTqAct_RL_BCh1: [5, 0],
  // WhlBrkTqAct_RR_BCh1: [5, 0],
  // DrvrReqTrgtFxBrk_Bch1: [1, -125000],
  // VehSdsl: [3, 0],
  // ACULongdAcc: [0.0002, -5],
  // SusIMUPitch: [0.1, -5],
  UIRx_BrkPdlPositionAct: [0.1, 0],
  UIRx_MassEstiMod: [1, 0],
  UIRx_VehMass: [5, 0],
  UIRx_FLVertDynF: [50, 0],
  UIRx_FRVertDynF: [50, 0],
  UIRx_RLVertDynF: [50, 0],
  UIRx_RRVertDynF: [50, 0],
  UIRx_FxyFL: [50, 0],
  UIRx_FxyFR: [50, 0],
  UIRx_FxyRL: [50, 0],
  UIRx_FxyRR: [50, 0],
  UIRx_ThetaFxyFA: [1, 0],
  UIRx_ThetaFxyRA: [1, 0],
  UIRx_BetaObs: [0.05, -25],
  UIRx_AWSFrontAngAdd: [0.01, -1],
  UIRx_PinionTarVgr: [0.1, -780],
  UIRx_PinionAct: [0.1, -780],
  UIRx_BrakeAirGap: [0.01, -1.5],
  UIRx_TTL: [10, 50],
  UIRx_AccelPdlPos: [1, 0],
  UIRx_HDCAvlbl: [1, 0],
  UIRx_HDCDispVxTar: [1.2, 0],
  UIRx_HDCCtrlA: [1, 0],
  UIRx_VAFBrkFxTrgt: [10, -40000],
} as Dictionary<number[]>;

// 信号转换数字转布尔
export const signalTransformNum2Bool = (data: number) => {
  // 0 => false ; 1 => false
  return Number(data) === 0 ? false : true;
};
// 信号转换布尔转数字
export const signalTransformBool2Num = (data: boolean) => {
  // false => 0 ; true => 1
  return data ? 1 : 0;
};
// 信号转换
export class SignalTransform {
  factor: Decimal;
  offset: Decimal;
  constructor(factor: Decimal.Value, offset: Decimal.Value) {
    this.factor = new Decimal(factor);
    this.offset = new Decimal(offset);
  }
  parse(data: Decimal.Value) {
    let a = new Decimal(data);
    // data * factor + offset
    let result = a.mul(this.factor).plus(this.offset);
    // console.log("parse Result:", result.toString());
    return result.toNumber();
  }
  build(data: Decimal.Value) {
    let a = new Decimal(data);
    // (data - offset )/ factor
    let result = a.minus(this.offset).div(this.factor);
    // console.log("build Result:", result.toString());
    return result.toNumber();
  }
}

const fixKey = (key: string) => {
  key = !key.includes("UIRx_") && !key.includes("UITx_") ? "UIRx_" + key : key;
  return key;
};

export const parseSignalObject = (
  data: any & Dictionary<number>,
  showlog = false
) => {
  if (showlog) console.log("parseSignalObject 原始值 :", data);
  const result = Object.keys(data).reduce((per, key) => {
    const rawValue = data[key];
    // 补充前缀 UIRx_
    key = fixKey(key);
    let signal = signalTransformMap[key];
    if (!signal) {
      signal = defaultSignalTransform;
      console.warn(`parseSignalObject ${key} 没有找到转换规则`);
    }
    let transform = new SignalTransform(signal[0], signal[1]);
    const value = transform.parse(rawValue);
    // console.log("[BOWEN_LOG] 🚀 ~~ parseSignalObject ~~ value:",signal, value);
    return {
      ...per,
      [key]: value,
    };
  }, {} as any);
  if (showlog) console.log("parseSignalObject 转换后 :", result);
  return result;
};
export const buildSignalObject = (data: any, showlog = false) => {
  if (showlog) console.log("buildSignalObject 原始值 :", data);
  const result = Object.keys(data).reduce((per, key) => {
    let signal = signalTransformMap[key];
    if (!signal) {
      signal = defaultSignalTransform;
      console.warn(`buildSignalObject ${key} 没有找到转换规则`);
    }
    let transform = new SignalTransform(signal[0], signal[1]);
    const value = transform.build(data[key]);
    return {
      ...per,
      [key]: value,
    };
  }, {} as any);
  if (showlog) console.log("buildSignalObject 转换后 :", result);
  return result;
};
